import request from '../request'

const importApis = {
  uploadFile: (payload) => request.post(`/import-excel`, payload),
  // getdetail: (id) => request.post(`/import/detail/${id}`),
  getdetail: (id) => request.post(`/shop-packages`),
  getListFile: (query) => request.get(`/uploaded-file${query}`),
  countPackageByImportManagerId: (id) => request.get(`import-managers/${id}/count-package`),
  getArrPackageCodeByImportManagerId: (id) => request.get(`import-managers/${id}/arr-package`)
}

export default importApis;